import * as React from "react";
import { forwardRef } from "react";
const SvgAzure = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "currentColor", viewBox: "0 0 24 24", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M23 20 14.659 5.426l-3.255 6.554 5.73 6.64L6.5 19.828zM6.546 9.091 1 18.448l4.721-.474 8.296-15.135z" }));
const ForwardRef = forwardRef(SvgAzure);
export default ForwardRef;
